import { createStandaloneToast, ToastProps } from '@chakra-ui/react'
import { themeMercedes } from 'theme'

const { toast } = createStandaloneToast({ theme: themeMercedes })

export const customToast = {
  showToast: ({
    title,
    description,
    status = 'error',
    variant = 'left-accent',
    duration = 10000,
    position = 'top',
    isClosable = true,
    ...props
  }: ToastProps) => {
    toast({
      title,
      description,
      status,
      variant,
      duration,
      position,
      isClosable,
      ...props
    })
  },
}
